// extracted by mini-css-extract-plugin
export default {"wrapper":"UserHeader_wrapper__FKOfT","pic":"UserHeader_pic__eTo5s","picInner":"UserHeader_picInner__8eClN","userPopUp":"UserHeader_userPopUp__gfYzK"};